import { createTheme } from '@mui/material';
import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';
import { StyledTextInput } from '../../../theme/Styles';

export const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
});


export const StyledTextField = styled(StyledTextInput)(props =>({
 /*  borderWidth: props.hideBorder ? '0' : '50px',
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderWidth:props.hideBorder ? '0' : '1px',
        },
        '&.Mui-focused fieldset': {
          borderWidth:props.hideBorder ? '0' : '1px',
        },
      }, */
}))